export default class BaseModel {

	constructor(object) {
		for(let i in object) {
			this[i] = object[i]
		}
	}

}